import type { ReactNode } from 'react'

export interface LoginShellProps {
  children: ReactNode
}

export function LoginShell({ children }: LoginShellProps) {
  return (
    <div className="login-shell vcc-app">
      <div className="login-route-outlet">
        <div className="login-route-outlet__page">{children}</div>
      </div>
    </div>
  )
}
